import { useEffect } from 'react';

const SEO_DATA = {
  '/': {
    title: 'Sarvaguna Academy | Best Vocational Education and Training Academy in Nepal | CTEVT Certified',
    description: 'Nepal\'s leading vocational education and training academy. Join our CTEVT-certified 24-month Mass Catering Professionals program. Hands-on kitchen training, job placement support. Apply for Third Batch starting July 2026.',
    keywords: 'vocational training Nepal, cooking classes Pokhara, CTEVT certified culinary school, dual-VET Nepal, mass catering course, chef training Nepal, hospitality training Pokhara',
    canonical: 'https://sarvagunaacademy.com/'
  },
  '/program': {
    title: 'Mass Catering Professionals Program | 24-Month CTEVT Certified Course | Sarvaguna Academy',
    description: 'Enroll in Nepal\'s premier 24-month Dual-VET program. Learn cooking, baking, barista skills, bulk cooking & food preservation. 4 days practical + 2 days classroom. CTEVT certified.',
    keywords: 'mass catering course Nepal, chef training program, cooking certification Nepal, hospitality training, food service education, CTEVT program Pokhara',
    canonical: 'https://sarvagunaacademy.com/program'
  },
  '/about': {
    title: 'About Sarvaguna Academy | Nepal\'s Leading Vocational Training Institute',
    description: 'Learn about Sarvaguna Academy, an initiative of Sarvaguna Foods & Kitchen. Our mission to empower youth through dual-vocational education. Meet our team of expert chef trainers in Pokhara.',
    keywords: 'about Sarvaguna Academy, vocational school Nepal, dual-VET institute, chef school Pokhara, cooking academy Nepal',
    canonical: 'https://sarvagunaacademy.com/about'
  },
  '/gallery': {
    title: 'Gallery | Sarvaguna Academy Kitchen Training & Events Photos',
    description: 'View photos from Sarvaguna Academy\'s culinary training sessions, graduation ceremonies, and kitchen operations. See our students learning professional cooking skills in Pokhara.',
    keywords: 'culinary training photos Nepal, cooking school gallery, chef training images, kitchen training Pokhara',
    canonical: 'https://sarvagunaacademy.com/gallery'
  },
  '/contact': {
    title: 'Contact Sarvaguna Academy | Vocational Training Inquiries Nepal',
    description: 'Contact Sarvaguna Academy for vocational training inquiries. Located in Pokhara, Nepal. Call +977 9802852978 or email info@sarvagunaacademy.com. Visit us today!',
    keywords: 'contact vocational school Nepal, cooking classes inquiry Pokhara, chef training admission Nepal',
    canonical: 'https://sarvagunaacademy.com/contact'
  },
  '/apply': {
    title: 'Apply Now | Third Batch July 2026 | Sarvaguna Academy Mass Catering Program',
    description: 'Apply for Sarvaguna Academy\'s Third Batch starting July 2026. Only 15 spots available for the 24-month Mass Catering Professionals program. Start your chef career today!',
    keywords: 'apply vocational school Nepal, chef training admission, mass catering enrollment, Sarvaguna Academy application',
    canonical: 'https://sarvagunaacademy.com/apply'
  }
};

export const useSEO = (pathname) => {
  useEffect(() => {
    const seoData = SEO_DATA[pathname] || SEO_DATA['/'];
    
    // Update title
    document.title = seoData.title;
    
    // Update meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };
    
    updateMetaTag('description', seoData.description);
    updateMetaTag('keywords', seoData.keywords);
    updateMetaTag('og:title', seoData.title, true);
    updateMetaTag('og:description', seoData.description, true);
    updateMetaTag('og:url', seoData.canonical, true);
    updateMetaTag('twitter:title', seoData.title);
    updateMetaTag('twitter:description', seoData.description);
    updateMetaTag('twitter:url', seoData.canonical);
    
    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', seoData.canonical);
    }
    
  }, [pathname]);
};

export default useSEO;
